export const FETCH_CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const FETCH_CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS_CREATE';
export const FETCH_CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';
export const REMOVE_LOADER = 'REMOVE_LOADER';
export const REMOVE_ERROR = 'REMOVE_ERROR';
